import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";

export function detectDeviceLang() {
  if (typeof navigator === "undefined") return "en";
  const prefs = navigator.languages?.length ? navigator.languages : [navigator.language || "en"];
  for (const p of prefs) {
    const code = String(p).slice(0, 2).toLowerCase();
    if (["en", "es", "fr"].includes(code)) return code;
  }
  return "en";
}

const stored = (typeof window !== "undefined" && localStorage.getItem("summit.lang")) || detectDeviceLang();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
  },
  lng: stored,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnObjects: true,
});

export default i18n;
